import { useLayoutEffect, useRef, useState } from "react";
const isOverflowingOnAxis = (element, axis) => {
    const overflowsX = element.scrollWidth > element.clientWidth + 1;
    const overflowsY = element.scrollHeight > element.clientHeight + 1;
    if (axis === "x")
        return overflowsX;
    if (axis === "y")
        return overflowsY;
    return overflowsX || overflowsY;
};
const useIsOverflowing = (ref, axis = "both") => {
    const resizeObserver = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    useLayoutEffect(() => {
        const element = ref.current;
        if (element) {
            resizeObserver.current = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    setIsOverflowing(isOverflowingOnAxis(entry.target, axis));
                }
            });
            resizeObserver.current.observe(element);
            return () => {
                var _a;
                if (element)
                    (_a = resizeObserver.current) === null || _a === void 0 ? void 0 : _a.unobserve(element);
            };
        }
    }, [ref, axis]);
    return isOverflowing;
};
export default useIsOverflowing;
//# sourceMappingURL=useIsOverflowing.js.map